import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/prod-order", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/prod-order/csv", params);
};

const upsert = data => {
  return restApi.post("/api/prod-order/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/prod-order/${ids}`);
};

const checkDuplicateOrderNum = params => {
  return restApi.get("/api/prod-order/duplicate-check", { params });
}

const checkInventory = params => {
  return restApi.post("/api/prod-order/inventory-check", params );
}

const prodOrderService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
  checkDuplicateOrderNum,
  checkInventory
};

export default prodOrderService;